export const ORG_ID = "60e6cd9df9c32f00072b71f8";
export const MEMBER_SERVICES_URL = "https://api.trdr.money/graphql/trdr-member-services";
export const ADMIN_SERVICES_URL = "https://api.trdr.money/graphql/trdr-admin-services";
export const ORG_SERVICES_URL = "https://api.trdr.money/graphql/trdr-org-services";

export function getAdminToken() {
  return localStorage.getItem("token");
}

export function setAdminToken(token) {
  localStorage.setItem("token", token);
}

export function clearAdminAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("session-key");
  localStorage.removeItem("user_info");
}

export function parseJwt(token) {
  if (!token) return null;
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export function isTokenExpired(token) {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return false;
  return Date.now() >= payload.exp * 1000;
}

export function getAdminUser() {
  const token = getAdminToken();
  return parseJwt(token);
}

export function hasAdminRole(role = "org_admin") {
  const user = getAdminUser();
  if (!user) return false;
  if (user.role === role || user.roles?.includes?.(role)) return true;
  // If role is org_admin, also allow super_admin
  if (user.role === "super_admin" || user.roles?.includes?.("super_admin")) return true;
  return false;
}

export function handleUnauthorized(f7, f7router, message = "Invalid credentials or session expired") {
  clearAdminAuth();
  if (f7 && f7.dialog) {
    f7.dialog.alert(message, () => {
      if (f7router) {
        f7router.navigate("/");
      } else {
        window.location.href = "/";
      }
    });
  } else if (f7router) {
    f7router.navigate("/");
  } else {
    window.location.href = "/";
  }
}

export function checkAdminAuth({ router, to, from, resolve, reject }) {
  const token = getAdminToken();
  if (!token || isTokenExpired(token)) {
    clearAdminAuth();
    reject();
    router.navigate("/");
    return;
  }
  resolve();
}
